import React from "react";
import { Card } from '@curves/ui-base';

import {CyclePurchaseDetailFutureCard } from "@Local/CyclePurchase/Detail/Future/";
const CyclePurchaseDetailFuture = (props) => {
	const { memberID, cycleOrderID, clubName } = props;
	return (
		<Card className="p-4">
			<CyclePurchaseDetailFutureCard memberID={memberID} cycleOrderID={cycleOrderID} clubName={clubName} />
		</Card>
	);
};
export default CyclePurchaseDetailFuture;
